<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            name: String,
            target: String,
            hasErrors: Boolean,
        },
        methods: {
            emitToVM(...args) {
                // do nothing in this context
            }
        }
    };
</script>
